import PropTypes from 'prop-types';

import { CustomAttribute } from 'hb-react/shared/components/formik/components/inputs';

const UserCustomAttributes = ({ userCustomAttributes = [] }) => (
  <>
    {userCustomAttributes.map((userCustomAttribute) => {
      const { id, name } = userCustomAttribute;
      const inputName = `donation_order[${name}]`;

      return (
        <div key={id} className="grid__item one-half palm--one-whole">
          <CustomAttribute
            name={inputName}
            customAttribute={userCustomAttribute}
          />
        </div>
      );
    })}
  </>
);

UserCustomAttributes.propTypes = {
  userCustomAttributes: PropTypes.array,
};

export default UserCustomAttributes;
